// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gKpv","left":"styles_left__13sZ_"};